import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubblePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubblePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H15.2858L11.9951 21.7263L8.74274 19H3V3ZM12.75 7L11.25 7L11.25 10.25H8V11.75H11.25V15H12.75V11.75H16V10.25H12.75L12.75 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubblePlus;
